<template>
  <div class="pay-status-container">
    <div class="status-content">
      <!-- 认证成功状态 -->
      <div v-if="passed == 1" class="status-success">
        <div class="success-icon">
          <div class="icon-circle">
            <i class="el-icon-check"></i>
          </div>
          <div class="icon-glow"></div>
          <div class="decorative-dots">
            <span class="dot dot-yellow"></span>
            <span class="dot dot-orange"></span>
            <span class="dot dot-green"></span>
          </div>
        </div>

        <h1 class="status-title success-title">恭喜您, 认证成功</h1>
        <p class="status-message" v-if="type == 2">感谢您对平台的支持，企业认证需等待客服审核</p>
        <p class="status-message" v-if="type == 1">感谢您对平台的支持</p>

        <div class="action-buttons">
          <el-button type="primary" class="btn-primary" @click="goHome">返回首页</el-button>
        </div>
      </div>

      <!-- 认证失败状态 -->
      <div v-else-if="passed==2" class="status-failed">
        <div class="failed-icon">
          <div class="icon-circle">
            <i class="el-icon-close"></i>
          </div>
          <div class="icon-glow"></div>
          <div class="decorative-dots">
            <span class="dot dot-orange"></span>
            <span class="dot dot-pink"></span>
            <span class="dot dot-red"></span>
          </div>
        </div>

        <h1 class="status-title failed-title">抱歉, 认证失败</h1>
        <p class="status-message">感谢您对平台的支持</p>

        <div class="action-buttons">
          <el-button type="primary" class="btn-primary" @click="goHome">返回首页</el-button>
        </div>
      </div>
      <div v-else class="status-failed">
        <div class="failed-icon">
          <div class="icon-circle">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <h1 class="status-title failed-title">认证不存在</h1>
        <p class="status-message">感谢您对平台的支持</p>
        <div class="action-buttons">
          <el-button type="primary" class="btn-primary" @click="goHome">返回首页</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rzNotice',
  data() {
    return {
      type: 0,
      passed: 0,
    }
  },

  created() {
    this.type = this.$route.query.type ? this.$route.query.type : -1
    this.passed = this.$route.query.passed ? this.$route.query.passed : -1
    console.log(this.type,this.passed)

  },
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.pay-status-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
}

.status-content {
  /* background: white; */

  text-align: center;
  /* box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15); */
  /* max-width: 600px; */
  width: 100%;
  position: relative;
}

.status-success .success-icon {
  position: relative;
  margin-bottom: 30px;
}

.status-success .icon-circle {
  width: 100px;
  height: 100px;
  background: #07c160;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.status-success .icon-circle i {
  color: white;
  font-size: 50px;
  font-weight: bold;
}

.status-success .icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(7, 193, 96, 0.3) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 1;
}

.status-failed .failed-icon {
  position: relative;
  margin-bottom: 30px;
}

.status-failed .icon-circle {
  width: 100px;
  height: 100px;
  background: #ff4757;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.status-failed .icon-circle i {
  color: white;
  font-size: 50px;
  font-weight: bold;
}

.status-failed .icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background: radial-gradient(circle, rgba(255, 71, 87, 0.3) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 1;
}

.decorative-dots {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.dot {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: float 3s ease-in-out infinite;
}

.dot-yellow {
  background: #ffd700;
  top: 20%;
  left: 15%;
  animation-delay: 0s;
}

.dot-orange {
  background: #ff8c00;
  top: 30%;
  right: 20%;
  animation-delay: 0.5s;
}

.dot-green {
  background: #32cd32;
  bottom: 25%;
  left: 25%;
  animation-delay: 1s;
}

.dot-pink {
  background: #ff69b4;
  top: 40%;
  left: 10%;
  animation-delay: 0.3s;
}

.dot-red {
  background: #dc143c;
  bottom: 20%;
  right: 25%;
  animation-delay: 0.8s;
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }
}

.status-title {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #333;
}

.success-title {
  color: #07c160;
}

.failed-title {
  color: #ff4757;
}

.status-message {
  font-size: 20px;
  color: #666;
  margin-bottom: 50px;
  line-height: 1.6;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary {
  background: #2682ff;
  border-color: #2682ff;
  color: white;
  padding: 16px 32px;
  font-size: 18px;
  border-radius: 10px;
  min-width: 140px;
  font-weight: 600;
}

.btn-primary:hover {
  background: #1a6fd8;
  border-color: #1a6fd8;
}

.btn-secondary {
  background: white;
  border-color: #ddd;
  color: #666;
  padding: 16px 32px;
  font-size: 18px;
  border-radius: 10px;
  min-width: 140px;
  font-weight: 600;
}

.btn-secondary:hover {
  border-color: #2682ff;
  color: #2682ff;
}

@media (max-width: 768px) {
  .status-content {
    padding: 50px 30px;
    margin: 20px;
  }

  .status-title {
    font-size: 28px;
  }

  .status-message {
    font-size: 16px;
  }

  .action-buttons {
    flex-direction: column;
    align-items: center;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    max-width: 250px;
    padding: 14px 24px;
    font-size: 16px;
  }
}

.status-content {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.icon-circle {
  animation: scaleIn 0.8s ease-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}
</style>
